import { render, staticRenderFns } from "./ButtonAssetInfo.vue?vue&type=template&id=66938c51&scoped=true"
import script from "./ButtonAssetInfo.vue?vue&type=script&lang=js"
export * from "./ButtonAssetInfo.vue?vue&type=script&lang=js"
import style0 from "./ButtonAssetInfo.vue?vue&type=style&index=0&id=66938c51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66938c51",
  null
  
)

export default component.exports